<template>
  <v-app id="inspire">
    <router-view></router-view>
    <notifications
      group="general"
      position="top right"
      animation-type="velocity"
    />
  </v-app>
</template>

<script>
import axios from 'axios'
import appConfig from '@/config/appConfig'

export default {
  data () {
    return {
    }
  },
  created () {
    this.$notify({
      duration: 10000,
    })
  }
}
</script>